/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export const DURATION_STEPS = [ 2, 3, 4, 6, 8, 12, 24 ];


export const getRounds = (settings, duration) =>
{
  return DURATION_STEPS[duration] * settings.getBoardScoreRounds();
};


// cpp create_board_args minus `user` (cpp backfills identity from the socket).
const buildArgs = ({ colony, args }) =>
{
  const payload = {};

  payload.galaxy = colony.cass.galaxy;
  payload.colony = colony.cass.id;

  payload.rounds = getRounds(colony.getSettings(), args.duration);
  payload.risk = args.risk;

  return payload;
};


// Mirrors the cpp create_board checks on the board parameters, in handler order.
const validate = ({ colony, args }) =>
{
  const settings = colony.getSettings();

  const rounds = getRounds(settings, args.duration);

  const issues = [];

  if (rounds < settings.getMinBoardRounds() || rounds > settings.getMaxBoardRounds())
  {
    issues.push('Board rounds must be between ' + settings.getMinBoardRounds() + ' and ' + settings.getMaxBoardRounds());
  }

  if (rounds % settings.getBoardScoreRounds() !== 0)
  {
    issues.push('Board rounds must be a multiple of ' + settings.getBoardScoreRounds());
  }

  if (args.risk < settings.getMinBoardRisk() || args.risk > settings.getMaxBoardRisk())
  {
    issues.push('Board risk must be between ' + settings.getMinBoardRisk() + ' and ' + settings.getMaxBoardRisk());
  }

  return { valid: issues.length === 0, issues };
};


const isAvailable = ({ colony, account }) =>
{
  return colony.cass.user === account.cass.id && !colony.cass.board;
};


export default
{
  type: 'solis/board/create',
  scope: 'createBoard',
  inputs: { duration: 1, risk: 0.2 },

  isAvailable,
  buildArgs,
  validate,
};
